"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANNUAL_TOTAL = exports.PAY_ADVICE = void 0;
var PAY_ADVICE = 'pay_advice';
exports.PAY_ADVICE = PAY_ADVICE;
var ANNUAL_TOTAL = 'annual_total';
exports.ANNUAL_TOTAL = ANNUAL_TOTAL;